<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
    name: "IconManipulatorCar1"
})
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 31">
        <circle cx="16.8" cy="27" r="4"/>
        <path
            d="M71.7 7h-13l-1 8H57V3l-3.3-3H25v8l2-2V3l24 1 2 3v9h-1V7h-3v6H0v6h4v1h3v2h4v2H7v1h4.9s1.8-3 5-3 4 3 4 3h2s.6-2.9 4.1-3c4.2-.1 5.1 4 5.1 4v1h29v-1s.5-4 5-4c4.2 0 5 4 5 4v1h2.7s2.3-.3 2.3-1V14l-4.4-7"/>
        <circle cx="26.8" cy="27" r="4"/>
        <circle cx="65.7" cy="27" r="4"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
